import Grid from '@mui/material/Grid';

import styles from './styles.module.css';

const Line = props => {
  return <Grid item className={styles['line--gradient']} {...props} />;
};

export default Line;
